<form [formGroup]="countrySelectionForm">
  <div class="flex-container">
    <div class="validated-form-field-container flex-container">
      <mat-form-field [appearance]="appearance" class="form-field flex-item">
        <mat-label>{{ countryFieldLabel }}</mat-label>
        <mat-select [formControlName]="COUNTRY_CONTROL" [placeholder]="'common.labels.country' | transloco"
          (selectionChange)="onCountryChange($event)" data-testid="country-dropdown">
          <mat-option>
            <ngx-mat-select-search [formControl]="countryFilterControl" [placeholderLabel]="labels.search"
              [noEntriesFoundLabel]="labels.noMatchesFound">
            </ngx-mat-select-search>
          </mat-option>
          @for (country of filteredCountries | async; track country.value) {
            <mat-option [value]="country.value"
              [attr.data-testid]="'country-option-' + country.label.replaceAll(' ', '-').toLowerCase()">
              {{ getDisplayLabel(country, 'country') }}
            </mat-option>
          }
        </mat-select>
        @if (countrySelectionForm.get(COUNTRY_CONTROL)?.value && countrySelectionForm.get(COUNTRY_CONTROL)?.enabled) {
        <mat-icon matPrefix role="button" tabindex="0" aria-hidden="false" (click)="clearCountry(); $event.stopPropagation();"
          (keydown.enter)="clearCountry(); $event.stopPropagation();"
          (keydown.space)="clearCountry(); $event.stopPropagation(); $event.preventDefault();" color="primary" [attr.aria-label]="'jurisdictionSelection.clearCountry' | transloco" data-testid="clear-country-button">
            cancel
        </mat-icon>
        }
      </mat-form-field>
      <lib-error-bubble [control]="countryFilterControl" [message]="countryError$"></lib-error-bubble>
    </div>

    @if (shouldShowJurisdictionDropdown) {
      <div class="validated-form-field-container flex-container">
        <mat-form-field [appearance]="appearance" class="form-field flex-item">
          <mat-label>{{ jurisdictionFieldLabel }}</mat-label>
          <mat-select [formControlName]="JURISDICTION_CONTROL" [placeholder]="'common.labels.jurisdiction' | transloco"
            (selectionChange)="onJurisdictionChange($event)" [multiple]="multiSelect"
            data-testid="jurisdiction-dropdown">
            <mat-option>
              <ngx-mat-select-search [formControl]="jurisdictionFilterControl" [placeholderLabel]="labels.search"
                [noEntriesFoundLabel]="labels.noMatchesFound">
              </ngx-mat-select-search>
            </mat-option>
            @for (jurisdiction of filteredJurisdictions | async; track jurisdiction.value) {
              <mat-option [value]="jurisdiction.value"
                [attr.data-testid]="'jurisdiction-option-' + jurisdiction.value?.toString()?.toLowerCase()">
                {{ getDisplayLabel(jurisdiction, 'jurisdiction') }}
              </mat-option>
            }
          </mat-select>
          @if (countrySelectionForm.get(JURISDICTION_CONTROL)?.value && countrySelectionForm.get(JURISDICTION_CONTROL)?.enabled) {
          <mat-icon matPrefix role="button" tabindex="0" aria-hidden="false" (click)="clearJurisdiction(); $event.stopPropagation();"
            (keydown.enter)="clearJurisdiction(); $event.stopPropagation();"
            (keydown.space)="clearJurisdiction(); $event.stopPropagation(); $event.preventDefault();" color="primary" [attr.aria-label]="'jurisdictionSelection.clearJurisdiction' | transloco" data-testid="clear-jurisdiction-button">
              cancel
          </mat-icon>
          }
        </mat-form-field>
        <lib-error-bubble [control]="jurisdictionFilterControl" [message]="jurisdictionError$"></lib-error-bubble>
      </div>
    }
    @if (!shouldShowJurisdictionDropdown) {
      <div class="validated-form-field-container flex-container">
        <mat-form-field appearance="outline" class="form-field flex-item">
          <mat-label>{{ jurisdictionFieldLabel }}</mat-label>
          <input matInput [libAutoCapitalize]="autoCapitalizeFields" [formControlName]="JURISDICTION_CONTROL" maxlength="2" [placeholder]="'common.labels.jurisdiction' | transloco"
            data-testid="jurisdiction-field" />
        </mat-form-field>
        <lib-error-bubble [control]="countrySelectionForm.get(JURISDICTION_CONTROL) ?? undefined" [message]="jurisdictionError$"></lib-error-bubble>
      </div>
    }
  </div>
</form>